import { render, staticRenderFns } from "./DashboardAssets.vue?vue&type=template&id=1b0a23ff&scoped=true&"
import script from "./DashboardAssets.vue?vue&type=script&lang=ts&"
export * from "./DashboardAssets.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAssets.vue?vue&type=style&index=0&id=1b0a23ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a23ff",
  null
  
)

export default component.exports